import { AuthResponse, LoginData, RegisterData, User } from '../types';
import { API_BASE_URL } from '../utils/network';
import { debugLog } from '../utils/debug';
import api from './apiClient';

export const authAPI = {
  login: async (data: LoginData): Promise<AuthResponse> => {
    try {
      debugLog('Attempting login with:', { email: data.email, baseURL: API_BASE_URL });
      const response = await api.post('/auth/login', data);
      debugLog('Login successful:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ Login error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: {
          url: error.config?.url,
          baseURL: error.config?.baseURL,
          method: error.config?.method
        }
      });
      throw error;
    }
  },

  register: async (data: RegisterData): Promise<AuthResponse> => {
    try {
      debugLog('Attempting register with:', { email: data.email, name: data.name, baseURL: API_BASE_URL });
      const response = await api.post('/auth/register', data);
      debugLog('Register successful:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ Register error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: {
          url: error.config?.url,
          baseURL: error.config?.baseURL,
          method: error.config?.method
        }
      });
      throw error;
    }
  },

  verify: async (): Promise<{ valid: boolean; user: User }> => {
    const response = await api.get('/auth/verify');
    return response.data;
  },
};
